<template>
    <div class="info-list">
        <Header/>
        <div class="blank20"/>
        <div class="rdg_biv_t">财务数据分析师全国统一报名入口</div>
        <div class="user_reg">
            <div class="r_tit">重置密码</div>
            <div class="blank20"/>
            <div class="l-r-content">
                <ResetModule style="border:0px"/>
            </div>
        </div>
        <div class="blank20"/>
        <Footer/>
    </div>
</template>
<script>
import ResetModule from './components/reset'
export default {
    data() {
        return {
            
        }
    },
    components:{
        ResetModule,
    },
    created() {
    },
    methods: {
    },
}
</script>
<style lang="scss" scoped>
@import '../assets/user.scss';
</style>
